'use strict';

/**
 * @fileoverview The ONE partial mask for an email address and a phone number (SECURITY-HARDENING-GEMS
 * Q-SG-24). A keyed field (`email`, `phone`) and a value found in free text are masked identically,
 * on the server and in the browser: enough of the value survives to find the record, not enough to
 * read the PII.
 *
 * @module @puffin-core/redaction/masks
 */

/**
 * Mask an email address: the first and last character of the local part survive.
 *
 * @param {*} email - Any value; only a string containing `@` with a non-empty local part is masked
 * @returns {*} The masked address, or the input unchanged
 */
function redactEmail(email) {
  if (typeof email !== 'string' || !email.includes('@')) {
    return email;
  }
  const at = email.indexOf('@');
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  if (local.length === 0) {
    return email;
  }
  if (local.length <= 2) {
    return `${local[0]}*@${domain}`;
  }
  return `${local[0]}${'*'.repeat(local.length - 2)}${local[local.length - 1]}@${domain}`;
}

/**
 * Mask a phone number to its last four digits.
 *
 * @param {*} phone - Any value; only a string with more than four digits is masked
 * @returns {*} `***-***-NNNN`, or the input unchanged
 */
function redactPhone(phone) {
  if (typeof phone !== 'string') {
    return phone;
  }
  const digits = phone.replace(/\D/g, '');
  if (digits.length <= 4) {
    return phone;
  }
  return `***-***-${digits.slice(-4)}`;
}

module.exports = { redactEmail, redactPhone };
